import styled from 'styled-components';

const DoubleWrap = styled.div`

    @media (min-width: 700px) {
        display: flex;

        /*& > div {
            width: calc(50% - 0.188rem);
        }*/

        & > *:not(:last-child){
            margin-right: 0.367rem;
          min-width: 25%;
        }
    } 
`;

export default DoubleWrap;
